import CopyButton from '@/src/components/AppComponents/CopyButton/CopyButton';
import { ModalDatum } from '@/src/components/AppComponents/ModalDatum/ModalDatum';
import OpenInNewTabButton from '@/src/components/AppComponents/OpenInNewTabButton/OpenInNewTabButton';
import LoaderButton from '@/src/components/Commons/LoaderButton/LoaderButton';
import { Token_With_Metadata_And_Amount } from '@/src/lib/MayzSmartDB/Commons/index';
import { formatAmountWithUnit, formatUTxO } from '@/src/lib/SmartDB/Commons/formatters';
import { UTxO } from '@lucid-evolution/lucid';
import styles from './DetailsUTxO.module.scss';
import { useDetailsUTxOs } from './useDetailsUTxO';

export const DetailsUTxOs = ({ uTxOs }: { uTxOs: UTxO[] }) => {
    //--------------------------------------
    const { appStore, isRefreshing, isLoadingList, isLoadedList, uTxOsWithDetails, refreshList } = useDetailsUTxOs({ uTxOs });
    //--------------------------------------
    return isLoadingList ? (
        <div className={styles.loadingDiv}>{<LoaderButton />}</div>
    ) : (
        <>
            <table className={styles.tableModal}>
                <thead>
                    <tr>
                        <th>Tx Hash # Output Index</th>
                        <th>Datum</th>
                        <th>Assets</th>
                        <th>Script Ref</th>
                    </tr>
                </thead>
                <tbody>
                    {uTxOsWithDetails.map((utxo, index) => (
                        <tr key={index}>
                            <td>
                                <div className={styles.itemWidthIcons}>
                                    {formatUTxO(utxo.txHash, utxo.outputIndex)}
                                    <CopyButton content={utxo.txHash + '#' + utxo.outputIndex} />
                                    <OpenInNewTabButton
                                        url={
                                            appStore.siteSettings !== undefined
                                                ? `${appStore.siteSettings.getblockfrost_url_explorer_utxo(utxo.txHash + '#' + utxo.outputIndex)}`
                                                : ``
                                        }
                                    />
                                </div>
                            </td>
                            <td>
                                <ModalDatum uTxO={utxo} />
                            </td>
                            <td>
                                <table className="ResetTable">
                                    <tbody>
                                        {utxo.assetWithDetails.map((asset: Token_With_Metadata_And_Amount, index: number) => (
                                            <tr key={index}>
                                                <td>{formatAmountWithUnit(asset.amount, asset.ticker, 2, true, asset.decimals)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </td>
                            <td>{utxo.hasScriptRef}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
    //--------------------------------------
};
